export const curveCategories = [
   {
      id: 'R',
      label: 'Urban Roundabout',
      radius: 25,
      description: 'Tight radius curves in industrial estates, depots, or roundabouts',
      advisory: 25,
      imgSrc: '/icons/curve-40.svg',
   },
   {
      id: 'A',
      label: 'Tight Rural / Collector',
      radius: 60,
      description: 'Sharp bends on rural collector roads or forestry access',
      advisory: 55,
      imgSrc: '/icons/curve-60.svg',
   },
   {
      id: 'B',
      label: 'Regional Connector Curve',
      radius: 100,
      description: 'Sub-arterial regional roads and unsignposted curves',
      advisory: 65,
      imgSrc: '/icons/curve-100.svg',
   },
   {
      id: 'C',
      label: 'Freight Route Curve',
      radius: 150,
      description: 'Typical freight corridors with advisory curve signage',
      advisory: 80,
      imgSrc: '/icons/curve-150.svg',
   },
   {
      id: 'D',
      label: 'Arterial Design Curve',
      radius: 250,
      description: 'Rural highways and high-volume arterial roads',
      advisory: 100,
      imgSrc: '/icons/curve-250.svg',
   },
   {
      id: 'E',
      label: 'High-Speed Highway Curve',
      radius: 400,
      advisory: 110,
      description: 'Major highways with gentle curves and design speed >100 km/h',
      imgSrc: '/icons/curve-400.svg',
   },
];

export function renderResults(unitIndex, srtResults, srtTarget) {
   const $container = $(`#speed-results-container-${unitIndex}`);
   $container.empty();
   const $messContainer = $(`#results-messages-${unitIndex}`);
   $messContainer.empty();

   resetSummaryResultCard(unitIndex);

   const { value, dataFieldError, dataWarning, calcError, reason } = srtResults;

   // --- Prepare resultData object to populate as we go
   const resultData = {
      srt: null,
      tiltAngle: null,
      passFail: null,
      srtTarget: srtTarget,
      grossMass: null,
      loadHeight: null,
      safeCurveSpeeds: [],
      messages: [],
   };

   window.srtReportResults = window.srtReportResults || {};
   window.srtReportResults[unitIndex] = resultData;

   if (dataFieldError) {
      console.log('SRT validation error:', reason);
      renderMessageCard('validation', unitIndex, reason);
      resultData.messages.push(reason);
      resultData.passFail = 'Error';
      showHideResults(unitIndex, false);
      return;
   }
   if (calcError) {
      console.log('SRT calculation error:', reason);
      renderMessageCard('error', unitIndex, reason);
      resultData.messages.push(reason);
      resultData.passFail = 'Error';
      showHideResults(unitIndex, false);
      return;
   }
   if (dataWarning) {
      console.log('SRT calculation warning:', reason);
      renderMessageCard('warning', unitIndex, reason);
      resultData.messages.push(reason);
   }

   const { srtMax: srt, tiltAngle } = value;

   if (srt && srt > 0.0 && srt < 1.3) {
      renderSummaryResultCard(unitIndex, srt, tiltAngle, srtTarget);

      // Calculate pass/fail status
      let passFail = 'Pending';
      if (srtTarget && !isNaN(Number(srtTarget))) {
         passFail = srt >= Number(srtTarget) ? 'Compliant' : 'Non-compliant';
      }

      // Populate resultData
      resultData.srt = srt;
      resultData.tiltAngle = tiltAngle;
      resultData.passFail = passFail;
      resultData.srtTarget = srtTarget;

      // Compute safe curve speeds
      const speedResults = computeSafeSpeeds(srt, curveCategories);
      resultData.safeCurveSpeeds = speedResults.map((row) => ({
         radius: row.radius,
         speed: row.safeSpeedKph,
      }));

      // Render grid cards as usual
      buildResultCards(unitIndex, speedResults);
      showHideResults(unitIndex, true);
   } else {
      const msg = "Couldn't render results, SRT was out of range: " + srt;
      console.log(msg, srtResults);
      renderMessageCard('error', unitIndex, msg);
      resultData.messages.push(msg);
      resultData.passFail = 'Error';
      showHideResults(unitIndex, false);
   }

   // --- Store for report modal use
   window.srtReportResults[unitIndex] = resultData;
}

function renderSummaryResultCard(unitIndex, srt, tiltAngle, srtTarget) {
   // --- Fade wrapper for summary card
   const $wrapper = $(`#srt-summary-body-${unitIndex}`);
   $wrapper.hide(); // Ensure it’s hidden before updating

   // --- SRT section updates
   const $srtResult = $(`#srt-result-${unitIndex}`);
   const $srtBadge = $(`#srt-result-badge-${unitIndex}`);

   const isCompliant = srt >= srtTarget;
   const statusColor = isCompliant ? 'success' : 'danger';

   // Update SRT badge and value
   $srtBadge
      .removeClass('bg-danger bg-success')
      .addClass(`bg-${statusColor}`)
      .text(isCompliant ? 'Compliant' : 'Non-compliant');
   $srtResult.removeClass('text-muted text-danger text-success').addClass(`text-${statusColor}`).text(srt.toFixed(3));

   // --- Tilt angle section updates
   const $tiltResult = $(`#tilt-angle-${unitIndex}`);
   $tiltResult.removeClass('text-muted text-danger text-success').addClass(`text-${statusColor}`).text(`${tiltAngle}`);

   // Fade in the updated card
   $wrapper.fadeIn(800);
}

export function resetSummaryResultCard(unitIndex) {
   // Reset SRT result card
   const $srtResult = $(`#srt-result-${unitIndex}`);
   const $srtBadge = $(`#srt-result-badge-${unitIndex}`);
   const $tiltResult = $(`#tilt-angle-${unitIndex}`);

   $srtBadge.removeClass('bg-danger bg-success').addClass('bg-secondary').text('');
   $srtResult.removeClass('text-muted text-danger text-success').addClass('text-muted').text('~');
   $tiltResult.removeClass('text-muted text-danger text-success').addClass(`text-muted`).text('~');
}

// Build and append speed result cards to the container
function buildResultCards(unitIndex, results) {
   const $container = $(`#speed-results-container-${unitIndex}`);
   $container.empty();

   const introHtml = `
  <p class="text-muted">
    Safe speed is the recommended advisory speed for a given curve radius,
    based on the vehicle’s configuration and determined Static Rollover Threshold (SRT).
    These speeds are adjusted slightly downward from ideal to allow for factors such as
    road surface, suspension effects, and measurement errors.
    Safe speeds are showed below - exceeding this speed may increase rollover risk
    They are intended as a guide only, exceeding them may increase rollover risk.
  </p>`;

   $container.append(introHtml);
   const $row = $('<div>', { class: 'row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3' });

   results.forEach((result) => {
      const card = createSpeedResultCardElement({ unitIndex, ...result });
      $row.append(card);
   });

   // Append row to wrapper, then wrapper to container
   // Create hidden wrapper
   const $fadeWrapper = $('<div>', { style: 'display: none;' });

   $fadeWrapper.append($row);
   $container.append($fadeWrapper);

   // Now fade in wrapper
   $fadeWrapper.fadeIn(800);
}

/**
 * Create a speed result card element for appending.
 */
function createSpeedResultCardElement(opts) {
   const { label, radius, safeSpeedKph, unitIndex, description, advisory, imgSrc = null } = opts;

   const $cardBody = $('<div>', { class: 'card-body text-center' });

   // Top label
   $('<h6>', { class: 'text-muted mb-2', text: label }).appendTo($cardBody);

   // Optional icon image
   if (imgSrc) {
      $('<img>', {
         src: imgSrc,
         alt: label,
         class: 'm-2',
         style: 'max-height: 80px;',
      }).appendTo($cardBody);
   }

   // Determine color class
   // The safe speed is the maximum recommended speed for the curve radius.
   // The advisory speed is a typical signed speed limit for the curve radius.
   // If the maximum safe speed is less than the advisory speed, use a warning color.
   const speedColor = safeSpeedKph < advisory ? 'text-warning' : 'text-success';

   // Limit displayed speed to 100Km/hr
   const safeSpeedKphTxt = safeSpeedKph > 100 ? '100+' : safeSpeedKph;

   // Speed display with conditional coloring
   $('<div>', {
      class: `display-6  ${speedColor}`,
      html: `<span class="speed-value">${safeSpeedKphTxt}</span> <small class="text-muted">km/h</small>`,
   }).appendTo($cardBody);

   // Optional advisory speed badge
   if (advisory) {
      $('<div>', {
         class: 'mt-2',
         html: `<span class="badge bg-secondary">for curve radius: ${radius} m</span>`,
      }).appendTo($cardBody);
   }

   return $('<div>', { class: 'col' }).append($('<div>', { class: 'card shadow-sm h-100' }).append($cardBody));
}

/**
 * Calculate safe speeds (km/h) for each curve category given an SRT.
 */
function computeSafeSpeeds(srt, categories, opts = {}) {
   const g = 9.81;
   const factor = opts.safetyFactor ?? 0.9; // 10% reduction default, or  ..
   const margin = opts.marginKph ?? 5; // 5 km/h margin

   return categories.map((cat) => {
      const speedMs = Math.sqrt(srt * g * cat.radius);
      let speedKph = speedMs * 3.6; // ideal physics speed

      const reducedByFactor = speedKph * factor; // ideal speed reduced by factor
      const reducedByMargin = speedKph - margin; // ideal speed reduced by margin
      // Take the lower of the two reductions.
      speedKph = Math.min(reducedByFactor, reducedByMargin);

      return {
         ...cat,
         safeSpeedKph: Math.max(0, Math.round(speedKph)),
      };
   });
}

export function renderMessageCard(type, unitIndex, message) {
   const $container = $(`#results-messages-${unitIndex}`);
   $container.empty();

   // Determine styling and label
   let borderClass, titleText, titleClass;
   switch (type) {
      case 'validation':
         borderClass = 'border-danger';
         titleText = 'Invalid Input';
         titleClass = 'text-danger';
         break;
      case 'error':
         borderClass = 'border-danger';
         titleText = 'Calculation Error';
         titleClass = 'text-danger';
         break;
      case 'warning':
         borderClass = 'border-warning';
         titleText = 'Warning';
         titleClass = 'text-warning';
         break;
      default:
         borderClass = 'border-secondary';
         titleText = 'Notice';
         titleClass = 'text-muted';
   }

   const $card = $('<div>', { class: `card ${borderClass} mb-3 shadow-sm` });
   const $body = $('<div>', { class: 'card-body text-center' }).appendTo($card);

   $('<h6>', { class: `${titleClass} mb-2`, text: titleText }).appendTo($body);
   $('<p>', {
      class: 'text-muted small mb-0 mx-auto  test-wrap',
      text: message || 'No additional details provided.',
      style: 'max-width: 650px;',
   }).appendTo($body);

   $container.append($card).show();
}

export function showHideResults(unitIdx, show) {
   let $chartsWrapper = $(`#charts-wrapper-${unitIdx}`);
   let $noChartsMessage = $(`#no-charts-message-${unitIdx}`);
   let $resultsContainer = $(`#speed-results-container-${unitIdx}`);
   let $noResultsMessage = $(`#no-results-message-${unitIdx}`);

   $chartsWrapper.toggle(show);
   $noChartsMessage.toggle(!show);
   $resultsContainer.toggle(show);
   $noResultsMessage.toggle(!show);
   // d-flex overrides the display class
   if (show) {
      $resultsContainer.removeClass('d-none');
   } else {
      $resultsContainer.addClass('d-none');
   }
}
